import { render } from "./LoadingCont.vue?vue&type=template&id=8f793156&scoped=true"
const script = {}

import "./LoadingCont.vue?vue&type=style&index=0&id=8f793156&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f793156"]])

export default __exports__